const questions = [
  {
    question:
      "As of late 2010, when smartphone innovation was reaching new heights, which iPhone model was the latest release on the market?",
    options: ["iPhone 5", "iPhone 4", "iPhone 4S", "iPhone 3GS"],
    answer: "iPhone 4",
    explanation:
      "In June 2010, Apple introduced the iPhone 4, featuring its groundbreaking Retina display. The previous 3GS had debuted in mid-2009, the upgraded 4S wouldn’t arrive until October 2011, and the iPhone 5 waited until September 2012.",
  },
  {
    question:
      "In 2010, Marvel Studios was laying the groundwork for its cinematic universe — which superhero film flew into theaters that year?",
    options: ["Iron Man", "Thor", "The Incredible Hulk", "Iron Man 2"],
    answer: "Iron Man 2",
    explanation:
      "On May 7, 2010, 'Iron Man 2' blasted onto the big screen, reuniting Robert Downey Jr. as Tony Stark. Earlier entries like 'Iron Man' and 'The Hulk' hit in 2008, while 'Thor' wouldn’t make its debut until May 2011.",
  },
  {
    question:
      "Back in February 2010, YouTube was still young — which creator reigned supreme with the most channel subscribers?",
    options: ["ShaneDawsonTV", "nigahiga", "Smosh", "Fred"],
    answer: "nigahiga",
    explanation:
      "Long before viral dance challenges, nigahiga topped the charts with 1.9 million subscribers thanks to his comedic sketches. Close contenders like Fred sat at 1.6M, Smosh at 1.3M, and ShaneDawsonTV around 1.2M.",
  },
  {
    question:
      "In 2010, global demographics shifted — which country stood as the most populous on Earth that year?",
    options: ["USA", "India", "Indonesia", "China"],
    answer: "China",
    explanation:
      "By mid-2010, China’s population topped approximately 1.34 billion, with India trailing at 1.17B, the U.S. at 309M, and Indonesia at 243M.",
  },
  {
    question:
      "At the 82nd Academy Awards in early 2010, which film won the Best Picture Oscar?",
    options: ["The Hurt Locker", "District 9", "The Blind Side", "Avatar"],
    answer: "The Hurt Locker",
    explanation:
      "Kathryn Bigelow’s intense Iraq War thriller 'The Hurt Locker' took home Best Picture on March 7, 2010, praised for its visceral tension. It beat out blockbuster epics like 'Avatar' and touching dramas such as 'The Blind Side.'",
  },
  {
    question:
      "By December 2010, music videos had become YouTube juggernauts — which song held the crown for most views?",
    options: [
      "Justin Bieber – Baby",
      "Shakira – Waka Waka",
      "Eminem – Love The Way You Lie",
      "Lady Gaga – Bad Romance",
    ],
    answer: "Justin Bieber – Baby",
    explanation:
      "Justin Bieber’s breakout hit 'Baby' racked up an astonishing 408 million views by year’s end, outpacing Lady Gaga’s 'Bad Romance' at 318M, Shakira’s World Cup anthem 'Waka Waka' at 256M, and Eminem’s 'Love The Way You Lie' at 231M.",
  },
  {
    question:
      "Football fever peaked at the 2010 FIFA World Cup — which nation lifted the trophy in South Africa?",
    options: ["Italy", "France", "Germany", "Spain"],
    answer: "Spain",
    explanation:
      "Spain claimed its first-ever World Cup title on July 11, 2010, defeating the Netherlands 1–0 in extra time thanks to Andrés Iniesta’s decisive goal, capping off an era of tiki-taka dominance.",
  },
  {
    question:
      "Time magazine honored individuals shaping our world in 2010 — who earned the Person of the Year title?",
    options: [
      "George W. Bush",
      "Mark Zuckerberg",
      "Barack Obama",
      "Pope Francis",
    ],
    answer: "Mark Zuckerberg",
    explanation:
      "In December 2010, Time recognized Facebook co‑founder Mark Zuckerberg as Person of the Year for transforming how people connect online, citing the social network’s explosive growth and cultural impact.",
  },
  {
    question:
      "Chilly passions ran high at the Winter Olympics — which city hosted the Games in February 2010?",
    options: ["Salt Lake City", "Vancouver", "Torino", "Beijing"],
    answer: "Vancouver",
    explanation:
      "From February 12–28, 2010, Vancouver welcomed athletes for snow sports and ice events, marking Canada’s first Winter Olympics since Calgary in 1988 and showcasing memorable moments like Crosby’s golden goal in hockey.",
  },
  {
    question:
      "Great movies dominated 2010 box offices — which film topped the global revenue charts that year?",
    options: [
      "Inception",
      "Toy Story 3",
      "Harry Potter and the Deathly Hallows: Part 1",
      "Alice in Wonderland",
    ],
    answer: "Toy Story 3",
    explanation:
      "Pixar’s 'Toy Story 3' hauled in over $1.07 billion worldwide, resonating with audiences of all ages. Close runner-up 'Alice in Wonderland' earned $1.03B, while Harry Potter and 'Inception' brought in $960M and $828M respectively.",
  },
  {
    question:
      "Modern websites were reshaping web traffic in 2010 — which site claimed the most U.S. visits that year?",
    options: ["Yahoo", "YouTube", "Facebook", "Google"],
    answer: "Facebook",
    explanation:
      "According to Hitwise data from January to November 2010, Facebook captured 8.93% of all U.S. website visits, overtaking Google’s 7.19% and cementing social networking as a web traffic leader.",
  },
  {
    question: "Who emerged as the most Googled person in 2010?",
    options: [
      "Justin Bieber",
      "Barack Obama",
      "Rebecca Black",
      "Mark Zuckerberg",
    ],
    answer: "Justin Bieber",
    explanation:
      "Teen sensation Justin Bieber dominated search trends in 2010, fueled by hit singles, a sold‑out tour, and a passionate fanbase that turned every new release into an internet event.",
  },
];

export default questions;
